export const Constants = {
  TAG_NAME: 'pop-credit-quality-chart-component',
  CREDIT_RATING: 'Credit rating',
  PERCENT_OF_PORTFOLIO: '% of portfolio',
  PERCENT_CHANGE: '% change',
  BENCHMARK: '% of benchmark',
} as const;
